import React from 'react';
import { useTranslation } from 'react-i18next';

interface StockSummaryProps {
  stockResumen: any;
}

export const StockSummary: React.FC<StockSummaryProps> = ({ stockResumen }) => {
  const { t } = useTranslation('createEditProductsModule');
  if (!stockResumen) return null;

  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-6 pt-4 border-b border-lines">
      <div className="col-span-1 md:col-span-2">
        <h2 className="text-lg font-semibold leading-tight mb-1">
          {t('sections.stock_manage_title')}
        </h2>
        <p className="text-sm">{t('sections.stock_manage_desc')}</p>
      </div>
      <div className="col-span-1 md:col-span-4 !mt-0">
        <div className="flex flex-row gap-4 mt-4">
          <div className="flex-1 bg-card-bg rounded-md border border-lines py-2 flex flex-col items-center">
            <span className="text-sm mb-1">
              {t('sections.stock_available')}
            </span>
            <span className="text-xl font-medium">
              {stockResumen.disponible}
            </span>
          </div>
          <div className="flex-1 bg-card-bg rounded-md border border-lines py-2 flex flex-col items-center">
            <span className="text-sm mb-1">{t('sections.stock_reserved')}</span>
            <span className="text-xl font-medium">
              {stockResumen.reservado}
            </span>
          </div>
          <div className="flex-1 bg-card-bg rounded-md border border-lines py-2 flex flex-col items-center">
            <span className="text-sm mb-1">{t('sections.stock_total')}</span>
            <span className="text-xl font-medium">
              {stockResumen.disponible + stockResumen.reservado}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
